// Central place to edit business details. Update this file to change contact info sitewide.
export const business = {
  name: "School Smiles Australia",
  tagline: "Mobile dental care for brighter futures",
  shortDescription:
    "School Smiles Australia brings a fully equipped mobile dental clinic directly to schools across Australia, providing child-friendly preventive care with minimal disruption to learning.",
  phone: "0494 585 885", // placeholder
  email: "info@schoolsmilesaustralia.com.au", // placeholder
  address: "Servicing schools across Australia", // placeholder
  hours: [
    { day: "Monday – Friday", time: "8:00 am – 5:00 pm" },
    { day: "Saturday", time: "By appointment" },
    { day: "Sunday", time: "Closed" },
  ],
  serviceArea: "Metropolitan and regional schools across Australia (service coverage subject to scheduling and travel).",
  parentConsentFormUrl:
    "https://docs.google.com/forms/d/e/1FAIpQLSfi14LAIs1EJxN2Vrbe7AfkrdeKxIqDjEIIjKj1VHdgt4plfQ/viewform?embedded=true",
  socials: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
};

export const images = {
  heroChildren:
    "https://images.unsplash.com/photo-1617056239820-8ce90ba48193?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxzY2hvb2wlMjBjaGlsZHJlbiUyMHNtaWxpbmclMjBvdXRkb29yc3xlbnwwfHx8fDE3ODQ0NDQ2NjV8MA&ixlib=rb-4.1.0&q=85",
  dentalVan: "/van.png",
  treatmentArea:
    "https://images.pexels.com/photos/9062527/pexels-photo-9062527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  friendlyDentist:
    "https://images.unsplash.com/photo-1593183230686-69876b0cb240?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxmcmllbmRseSUyMGRlbnRpc3QlMjBjaGlsZHxlbnwwfHx8fDE3ODQ0NDQ2NjV8MA&ixlib=rb-4.1.0&q=85",
  child2:
    "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?auto=format&fit=crop&w=1200&q=80",
  clinicRoom:
    "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=1200&q=80",
  team:
    "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&w=1200&q=80",
};
